import { React, useState, useEffect } from "react";
import { Button, Form, Input, Switch, Col, Row, Tooltip } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  DetailFields,
  HaberForm,
  RightDrawerContainer,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import { GlobalSet, Styled } from "../../pageStyled";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import {
  addNewGrade,
  getMachineGradeSelectForConfig,
  setOrderType,
  deleteQuality,
} from "../../../Services/settingsServices";
import { capital_letter } from "../../../Utils/helper/helper";

const AddQuality = (props) => {
  const [form] = Form.useForm();
  const [qualitiesList, setQualititesList] = useState([]);
  const [switchTooltip, setSwitchTooltip] = useState(true);
  const [newQuality, setNewQuality] = useState();
  const [newGradeAlert, setNewGradeAlert] = useState(false);
  const [addQualityAlert, setAddQualityAlert] = useState(false);
  const [deleteQualityAlert, setDeleteQualityAlert] = useState(false);
  const [addDeleteResponse, setAddDeleteResponse] = useState();
  const [qualityErr, setQualityErr] = useState(false);

  const showAlert = (setAlert) => {
    setAlert(true);
    setTimeout(() => setAlert(false), 2000);
  };

  useEffect(() => {
    showAlert(setNewGradeAlert);
  }, []);

  const updatedGrade = async () => {
    const resp = await getMachineGradeSelectForConfig();
    if (!resp.error) {
      const requiredGrade = resp.data.data.settings.grades.filter((item) => {
        return item.name === props.newGrade.name;
      });
      setQualititesList(requiredGrade[0].qualities);
    }
  };

  const handleClose = () => {
    props.onClose();
    setQualititesList([]);
  };

  const onFinish = (values) => {
    const reqBody = {
      grade: props.newGrade.name,
      quality: {
        name: capital_letter(values.quality_name?.trim()),
        description:values.quality_description?values.quality_description:'',
        value: true,
      },
    };

    addNewGrade(reqBody)
      .then((response) => {
        const quality = {
          name: capital_letter(values.quality_name?.trim()),
          description: values.quality_description?values.quality_description:'',
          value: true,
        };
        console.log(response);
        setAddDeleteResponse(response);
        setNewQuality(capital_letter(quality.name));
        showAlert(setAddQualityAlert);
        setQualititesList([...qualitiesList, quality]);
        form.resetFields();
        props.updateList();
      })
      .catch((error) => {
        // // console.log("Error in quality list adding:", error.response.data);
        // setAddDeleteResponse(error.response.data);
        
        if(error?.response?.status == 500){
          let res = {
            error: true,
            msg: "Something went wrong. Please try again"
          }
          setAddDeleteResponse(res);
        } else{
          let res = {
            error: true,
            msg: error?.response?.data?.msg
          }
          setAddDeleteResponse(res);
        }
        showAlert(setAddQualityAlert);
      });
  };

  const deleteQualityHandler = async (currentQuality) => {
    try {
      const response = await deleteQuality(
        props.newGrade.name,
        capital_letter(currentQuality.name)
      );
      if (!response.error) {
        updatedGrade();
        props.updateList();
        setAddDeleteResponse(response);
        setNewQuality(capital_letter(currentQuality.name));
        showAlert(setDeleteQualityAlert);
        //props.onClose();
      }
    } catch (error) {
      // console.log(error);
      // setAddDeleteResponse(error.response.data);
      // showAlert(setDeleteQualityAlert);

        if(error?.response?.status == 500){
          let res = {
            error: true,
            msg: "Something went wrong. Please try again"
          }
          setAddDeleteResponse(res);
        } else{
          let res = {
            error: true,
            msg: error?.response?.data?.msg
          }
          setAddDeleteResponse(res);
        }
        showAlert(setDeleteQualityAlert);
    }
  };

  const handleSwitchChange = async (checked, currentQuality) => {
    const requestBody = {
      grade: props.newGrade.name,
      quality: currentQuality.name,
      value: checked,
    };
    await setOrderType(requestBody)
      .then((response) => {
        //     setQualititesList(qualitiesList.map(quality=>(
        //             {...(quality.name === currentQuality.name&&
        //                {    name: quality.name,
        //                     description: quality.description,
        //                    value:checked
        //                 })
        //             }
        //     ))
        //     // setSwitchTooltip(checked);
        // )
        updatedGrade();
      })
      .catch((error) => {
        console.log("Error in editing grade quality change:", error);
        if(error?.response?.status == 500){
          let res = {
            error: true,
            msg: "Something went wrong. Please try again"
          }
          setAddDeleteResponse(res);
        } else{
          let res = {
            error: true,
            msg: error?.response?.data?.msg
          }
          setAddDeleteResponse(res);
        }
        showAlert(setDeleteQualityAlert);
      });
  };

  const onQualityChange = (event) => {
    setQualityErr(false);
    if(qualitiesList?.length > 0){
      qualitiesList?.forEach((quality) =>{
      if(quality.name?.toLowerCase () === event.target.value?.toLowerCase()){
        setQualityErr(true);
      }
    });
  }
  }

  return (
    <RightDrawerSidebar
      title={`Add qualities for ${props.newGrade.alias}`}
      subtitle={props.newGrade.name}
      visible={props.visible}
      extra={[<Button>OK</Button>]}
      onClose={handleClose}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          {newGradeAlert && (
            <AlertContainer
              color="green"
              icon={alertGreen}
              msg={`A new grade ${props.newGrade.name} is successfully added`}
            />
          )}
          {addQualityAlert && (
            <AlertContainer
              color={addDeleteResponse.error ? "red" : "green"}
              icon={addDeleteResponse.error ? alertRed : alertGreen}
              msg={
                addDeleteResponse.error
                  ? addDeleteResponse.msg
                  : `A new quality ${newQuality} is added to grade ${props.newGrade.name}`
              }
            />
          )}
          {deleteQualityAlert && (
            <AlertContainer
              color={addDeleteResponse.error ? "red" : "green"}
              icon={addDeleteResponse.error ? alertRed : alertGreen}
              msg={
                addDeleteResponse.error
                  ? addDeleteResponse.msg
                  : `Quality ${newQuality} is deleted`
              }
            />
          )}
          <AlertContainer
            color="blue"
            icon={alertBlue}
            msg="You can provide multiple qualities of this grade. You can’t modify a quality once added. A quality can only be deleted if there is no product created for that quality"
          />
          <GlobalSet style={{ textAlign: "left", marginTop: "16px" }}>
            <Button
              className="textTypeBtn textBtnIcon"
              style={{ marginLeft: "0" }}
            >
              <Iconmoon icon="addcircle" size={14} color="#EA655B" />
              Add a new quality
            </Button>
          </GlobalSet>
          <HaberForm>
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin haberSignup"
              style={{ marginTop: "0" }}
              onFinish={onFinish}
            >
              <div className="drawerField" style={{ paddingTop: "0" }}>
                <div
                  className="titleWithText dFlex"
                  style={{ justifyContent: "space-between", margin: "10px 0" }}
                >
                  <h5 style={{ alignSelf: "center" }}>Add a new quality</h5>
                  <GlobalSet
                    className="specialBtn adjCntBtn"
                    style={{ width: "calc(100% - 125px)" }}
                  >
                    <Styled styled={{ display: "flex" }}>
                      <Tooltip
                        placement="bottomRight"
                        title={"Cancel Quality"}
                        className="edit-tooltip"
                        getPopupContainer={(triggerNode) => triggerNode}
                      >
                        <Button
                          className="textTypeBtn noMargin blackTxt"
                          onClick={props.onClose}
                        >
                          Cancel
                        </Button>
                      </Tooltip>
                    </Styled>
                    <Styled styled={{ display: "flex" }}>
                      <Tooltip
                        placement="bottomRight"
                        title={"Save Quality"}
                        className="edit-tooltip"
                        getPopupContainer={(triggerNode) => triggerNode}
                      >
                        {" "}
                        <Button
                          className="textTypeBtn textBtnIcon"
                          htmlType="submit"
                        >
                          <Iconmoon
                            icon="addcircle"
                            size={14}
                            color="#EA655B"
                          />
                          Save
                        </Button>
                      </Tooltip>
                    </Styled>
                  </GlobalSet>
                </div>
                <Form.Item
                  name="quality_name"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                    {
                      max: 50,
                      message: "Name can have a maximum of 50 characters",
                    },
                    {
                      validator(_, value) {
                        if(qualityErr){
                        return Promise.reject("Quality name must be unique");
                        } else{
                          return Promise.resolve();
                        }
                      },
                    },
                  ]}
                  className=""
                >
                  <Input
                    placeholder="Enter name of the quality"
                    onChange = {onQualityChange}
                    style={{ textTransform: "capitalize" }}
                  />
                </Form.Item>
                <Form.Item
                  name="quality_description"
                  rules={[
                    {
                      max: 50,
                      message:
                        "Description can have a maximum of 50 characters",
                    },
                  ]}
                  className="textareaField"
                >
                  <Input.TextArea placeholder="Enter description of the quality" />
                </Form.Item>
              </div>
            </Form>
          </HaberForm>
          {/* {console.log("Qualities", qualitiesList)}
          {qualitiesList.map((quality) => {
            return (
              <Row className="centerAlign">
                <Col span={18}>
                  <div className="boxFieldTitle">
                    <label>{quality.name}</label>
                    <p>{quality.description}</p>
                  </div>
                </Col>
                <Col span={6}>
                            <div className="boxFormType">
                                <GlobalSet>
                                    <Styled className="dFlex centerAlignBtn" style={{ paddingLeft: '5px' }}>
                                        <Tooltip
                                            placement="bottomRight"
                                            title={switchTooltip ? "" : ""}
                                            getPopupContainer={(triggerNode) => triggerNode}
                                        >
                                            <Switch defaultChecked
                                                //onChange={handleSwitchChange}
                                                className="switch-new"
                                            />
                                        </Tooltip>
                                        <Button className="textTypeBtn edit-btn edit-tooltip deleteQtyBtn"><Iconmoon icon="delete" size={17} color="#605E5C" /></Button>
                                    </Styled>
                                </GlobalSet>
                            </div>
                        </Col>
              </Row>
            );
          })} */}

          {qualitiesList.length ? (
            <DetailFields>
              <div className="groupDetailWrap qualityRow">
                <Row gutter={[24, 24]} className="groupForm">
                  <Col span={24}>
                    {qualitiesList.reverse().map((quality, index) => {
                      return (
                        <Row className="centerAlign">
                          <Col span={18}>
                            <div className="boxFieldTitle">
                              <label>{capital_letter(quality.name)}</label>
                              <p>{quality.description}</p>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div className="boxFormType">
                              <GlobalSet>
                                <Styled
                                  className="dFlex centerAlignBtn"
                                  style={{ paddingLeft: "5px" }}
                                >
                                  <Tooltip
                                    placement="bottomRight"
                                    title={switchTooltip ? "" : ""}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode
                                    }
                                  >
                                    <Switch
                                      defaultChecked
                                      onChange={(e) =>
                                        handleSwitchChange(e, quality)
                                      }
                                      className="switch-new"
                                      checked={quality.value}
                                    />
                                  </Tooltip>
                                  <Button
                                    onClick={() =>
                                      deleteQualityHandler(quality)
                                    }
                                    // disabled={index === 0}
                                    className="textTypeBtn edit-btn edit-tooltip deleteQtyBtn"
                                  >
                                    <Iconmoon
                                      icon="delete"
                                      size={17}
                                      color="#605E5C"
                                    />
                                  </Button>
                                </Styled>
                              </GlobalSet>
                            </div>
                          </Col>
                        </Row>
                      );
                    })}
                  </Col>
                </Row>
              </div>
            </DetailFields>
          ) : (
            <></>
          )}
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  );
};
export default AddQuality;
